import axios from "@/lib/axios";

export type GetSuggestionsByQuestionIdRequestParams = {
  companyId: string;
  questionId: string;
};

export type GetSuggestionsByQuestionIdResponse = {
  questionId: string;
  editionYear: number;
  answers: [
    {
      answerId: string;
      answerValue: string;
    },
  ];
};

export const getSuggestionsByQuestionId = (
  params: GetSuggestionsByQuestionIdRequestParams,
) =>
  axios
    .get<GetSuggestionsByQuestionIdResponse>(
      `/v1/companies/${params.companyId}/suggestions/${params.questionId}`,
    )
    .then((r) => r.data);
